import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { concat, defer, Observable, forkJoin, of } from 'rxjs';
import { catchError, ignoreElements, shareReplay } from 'rxjs/operators';

@Injectable()
export class TranslateServiceRegistry {
  private readonly services: TranslateService[] = [];
  // TranslateService.use() switches the language whenever its translations finish loading, so concurrent changes
  // would be applied in completion order. Running them one after another makes the latest request win.
  private pendingChange$: Observable<unknown> = of(undefined);

  public register(translateService: TranslateService): void {
    this.services.push(translateService);
  }

  public changeLanguage(language: string): Observable<any> {
    const change$ = concat(
      this.pendingChange$.pipe(ignoreElements()),
      defer(() => this.useLanguage(language)),
    ).pipe(shareReplay({ bufferSize: 1, refCount: false }));
    this.pendingChange$ = change$;
    return change$;
  }

  private useLanguage(language: string): Observable<unknown[]> {
    const services = this.services.filter((service) => service.currentLang !== language);
    return services.length === 0 ? of([]) : forkJoin(services.map((service) => service.use(language).pipe(catchError(() => of({})))));
  }
}
